/* eslint-disable max-len */
import React from 'react';
import { Navbar, Sidebar } from '../../components';
import './index.css';
import AlertsTabs from './ds/AlertsTabs';

function Alerts() {
  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          <div className="mb-5">
            <h1 className="font-bold text-ink-900 leading-tight text-2xl lg:text-[32px] lg:leading-10" data-testid="title">
              Shoot Insights
            </h1>
            <p className="text-sm text-ink-500 mt-1" data-testid="subtitle">
              Monitor critical alerts, team performance, and engagement bot activity
            </p>
          </div>
          <AlertsTabs />
        </div>
      </div>
    </>
  );
}

export default Alerts;
